<template>
    <v-card>
        <v-card-title class="justify-center">
            <h2>EDITAR DESTINO</h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-select
                v-model="destino"
                outline
                label="Destino"
                single-line
                :items="destinos"
                item-text="text"
                item-value="value"
                class="mr-4 ml-4 mb-2 mt-2"
                required
                hide-details
                :rules="[
                    v => !!v || ''
                ]"
            />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
            <v-flex xs6>
                <v-btn
                    block
                    flat
                    @click="$emit('fechar')"
                >
                    Fechar
                </v-btn>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs6>
                <v-btn
                    block
                    flat
                    color="success"
                    :disabled="
                        !meioSelecionado ||
                        meioSelecionado.destino == destino
                    "
                    @click="atualizarPagamentoExtra"
                >
                    <v-icon class="mr-1">save</v-icon>
                    Salvar
                </v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>

export default {
  props: ['meioSelecionado'],
  data: () => ({
    destino: 1,
    destinos: [
        {
          text: 'Para Clientes',
          value: 1
        },
        {
          text: 'Para Postos',
          value: 2
        },
        {
          text: 'Para Empresas',
          value: 3
        },
        {
          text: 'Para Todos',
          value: 4
        },
        {
          text: 'Para Verificar o Cartão',
          value: 5
        }
    ]
  }),
  beforeMount () {
    if (this.meioSelecionado) {
        this.destino = this.meioSelecionado.destino
    }
  },
  methods: {
    atualizarPagamentoExtra () {
        this.$store.dispatch(
          'atualizarPagamentoExtra',
          {
            id: this.meioSelecionado.id,
            destino: this.destino
          }
        ).then(() => {
            this.$emit('showSnackbar',
            'Pagamento apagado com sucesso.',
            'primary'
          )
          this.$emit('fechar')
        }).catch(() => {
          this.$emit(
            'showSnackbar',
            'Não foi possível atualizar meio de recebimento',
            'error'
          )
        })
    }
  }
}

</script>
